import React from 'react';
import { Grid } from '@mui/material';

import { AuthorizerContext } from 'app/providers/acl/AclProvider';
import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionImage,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';

// import UsersDetailsSectionFiltersSaved from '../sections/UsersDetailsSectionFiltersSaved';
import UsersDetailsSectionInfo from '../sections/UsersDetailsSectionInfo';
import UsersDetailsSectionAddress from '../sections/UsersDetailsSectionAddress';
import UsersDetailsSectionConnectors from '../sections/UsersDetailsSectionConnectors';
import UsersDetailsSectionLoginSettings from '../sections/UsersDetailsSectionLoginSettings';
import UsersDetailsSectionSystemInfo from '../sections/UsersDetailsSectionSystemInfo';
import UsersDetailsSectionFiltersSaved from '../sections/UsersDetailsSectionFiltersSaved';

export default function UsersDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();
	const authorizer = React.useContext(AuthorizerContext);

	const canUpdateUsers = authorizer.can('update', 'users');

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<UsersDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={{ md: 6, xs: 12 }}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="map-marker" />}
							title={t('DETAILS_USERS_ADDRESS_RESIDENCE_SECTION')}
							subheader={t('DETAILS_USERS_ADDRESS_RESIDENCE_SUBHEADER')}
						>
							<UsersDetailsSectionAddress
								type="residence"
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={{ md: 6, xs: 12 }}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="map-marker" />}
							title={t('DETAILS_USERS_ADDRESS_DOMICILE_SECTION')}
							subheader={t('DETAILS_USERS_ADDRESS_DOMICILE_SUBHEADER')}
						>
							<UsersDetailsSectionAddress
								type="domicile"
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					{props.isEdit && props.model.user_uid && (
						<Grid size={12}>
							<DetailsSectionImage
								title={t('USERS_AVATAR_SECTION')}
								subheader={t('USERS_AVATAR_SUBHEADER')}
								isEdit
								fieldName="user_avatar"
								fileName={props.model.user_uid.toUpperCase()}
								path={`users\\${props.model.user_uid.toUpperCase()}`}
								value={props.model.user_avatar}
								grabberProps={{
									defaultSearch: `${props.model.user_name || ''} ${props.model.user_surname || ''}`
								}}
								sendChange={props.sendFilesChange}
							/>
						</Grid>
					)}
					<Grid size={12}>
						{props.isAdd ? (
							<DetailsSectionInfoWrapper
								avatar={<Icon icon="text-subject" />}
								title={t('USERS_SYSTEM_USER_CREATION_SECTION')}
								subheader={t('USERS_SYSTEM_USER_CREATION_SUBHEADER')}
							>
								<UsersDetailsSectionLoginSettings
									model={props.model}
									sendChange={props.sendChange}
									isEdit={props.isEdit}
								/>
							</DetailsSectionInfoWrapper>
						) : (
							<UsersDetailsSectionSystemInfo
								model={props.model}
								isEdit={props.isEdit}
								sendChange={props.sendChange}
							/>
						)}
					</Grid>
					<Grid size={{ xs: 12 }}>
						<UsersDetailsSectionFiltersSaved userUid={props.model.user_uid} />
					</Grid>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="connection" />}
							title={t('DETAILS_CONNECTORS_SECTION')}
							subheader={t('DETAILS_CONNECTORS_SUBHEADER')}
						>
							<UsersDetailsSectionConnectors
								model={props.model}
								isEdit={props.isEdit}
								sendChange={props.sendChange}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
